<template>
    <main id="hcid-wrapper">
        <div id="hcid-page" class="pb-4">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url: app_url+'/hcid', status: true }
                ]"
            ></breadcrumb>
            <ModalQR :cardNumber="qr.cardNumber" :size="qr.size" level="H" :user="user"></ModalQR>
            <div class="container-fluid title-row">
                <div class="container py-5">
                    <div class="row">
                        <div class="col">
                            <h2 class="title">Honda Community ID</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container py-4">
                <div class="card card-info">
                    <div class="card-body">
                        <div class="row">
                            <a :href="app_url+'/hcid'" class="btn btn-black py-2 my-2">Biodata</a>
                            <div class="col my-2">
                                <hr class="divider-hr">
                            </div>
                            <a :href="app_url+'/hcid/kopdar'" class="btn btn-red py-2 my-2">Kopdar</a>
                            <div class="col my-2">
                                <hr class="divider-hr">
                            </div>
                            <a :href="app_url+'/hcid/kta'" class="btn btn-black py-2 my-2">KTA</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container my-4">
                <div class="card card-info">
                    <div class="card-body">
                        <div class="center">
                            <h3>Anda Belum Mengikuti Komunitas</h3>
                            <p>Status Anda sedang dalam proses konfirmasi. Anda akan segera dihubungi oleh PIC Komunitas Anda. </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import ModalQR from "../../widget/ModalQR";
import HcidEventCard from "../../widget/HcidEventCard";
import Games from "../../widget/Games";

export default {
    components: {
        breadcrumb: BreadCrumb,
        ModalQR,
        HcidEventCard,
        Games,
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            titleClass: {
                'sub-title-list-transaksi': true,
            },
            selectedTitle: 'earn',
            qr: {
                cardNumber: 'HCID00099777',
                size: 247,
            },
            points:[],
            loaderpoint:true,
            mobile: false,
            user:null,
            endpoint:api_url+'/member/point?limit=5&type=tambah',
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
            this.getPoint();
        }
    },
    methods: {
        changeSelectedClass(data){
            this.selectedTitle = data;
            if(data == 'earn'){
                this.endpoint = api_url+'/member/point?limit=5&type=tambah';
            }else{
                this.endpoint = api_url+'/member/point?limit=5&type=kurang';
            }
            this.getPoint();
        },
        getPoint() {
                this.loaderpoint = true;
                var token = localStorage.getItem('token') ;
                axios.get(this.endpoint,{
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.points = response.data.data.point;
                        this.loaderpoint = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
    }
};
</script>

<style scoped lang="scss">
.center{
    text-align: center;
    padding:30px 0 10px 0;
}
#hcid-page{
    background: #000000;
    .card{
        background: #282828;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .title-row{
        background: #191919;
        opacity: 0.95;
    }
    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
    }
    .poin-head{
        max-height: 43px;
    }
    #poin-amount{
        vertical-align: sub;
    }
    .btn-tukar{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .btn-view{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px 10px;
        background: #E61B33;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .btn:hover{
        color: #FFFFFF;
    }
    .btn-red{
        background: #E61B33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }
    .btn-black{
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }
    .divider-hr{
        border: 1px dashed #B4B4B4;
    }
    .card-info{
        background: #1C1C1C;;
        border-radius: 10px;
    }
    .profile-img{
        border-radius:50%;
        max-height: 99px;
    }
    .row-name{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .row-club{
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        color: #B4B4B4;
    }
    .sub-title{
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF;
        border-bottom: 3px solid #FFFFFF;
        display: inline-flex;
    }
    .btn-see-more{
        background: #282828;
        border-radius: 10px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .btn-redeem{
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        background: #E61B33;
        border-radius: 10px;
    }
    .sub-title-list-transaksi{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 45px;
        color: #FFFFFF;
        cursor: pointer;
        display: inline-block;
        height: 45px;
        padding: 0 20px;
    }
    .selected-list-transaction{
        border-bottom: 4px solid #E61B33;
    }
    .hr-transaksi{
        opacity: 0.2;
        border: 1px solid #FFFFFF;
        margin-top: unset;
        margin-bottom: unset;
    }
    .img-poin{
        max-height: 50px;
    }
    .poin-value{
        left: -5px;
        top: 2px;
        position: absolute;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #000000;
        z-index: 100;
        width: 40px;
        height: 40px;
        font-size: 12px;
    }
    .poin-text{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
    }
    .date-content{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        color: #B4B4B4;
    }
    .title-content{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .col-title{
        text-align-last: justify;
    }
    .title-list-transaksi{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
        display: inline-flex;
        margin: unset;
    }
    @media (max-width: 768px) {
        .col-profile-image{
            max-width: fit-content;
        }
        .btn-view{
            margin:unset;
            display: table;
            margin-bottom: 0.5rem;
            margin-top: 0.5rem;
        }
        .title{
            padding-top: 2rem !important;
        }
        .img-card{
            max-height: 228.61px;
        }
        .name-card{
            font-size: 16px;
            line-height: 26px;
        }
        .detail-event{
            font-size: 12px;
        }
        .poin-head{
        max-height: 33px;
        }
        .col-left{
            width:auto;
        }
        .poin-value{
            left: 22px;
        }
        .sub-title{
            font-size: 16px;
            line-height: 26px;
        }
        .title-list-transaksi{
            font-size: 25px;
            line-height: 35px;
        }
        .btn-redeem{
            font-size: 12px;
            line-height: 25px;
        }
    }
}
</style>
